import { Controller, useFormContext } from 'react-hook-form';

import {
	AkselLocale,
	Textarea,
	TextField as AkselTextField,
} from 'components/form/aksel';

export default function TextField({
	name,
	label = null,
	textAlign = 'left',
	prefix = null,
	suffix = null,
	defaultValue = '',
	multiline = false,
	rows = undefined,
	maxRows = undefined,
	fullWidth = false,
	sx = null,
	// eslint-disable-next-line no-unused-vars -- Unused legacy prop.
	margin = undefined,
	inputRef = undefined,
	size = 'medium',
	...rest
}) {
	const { control } = useFormContext();

	const labelText = label ?? rest['aria-label'] ?? '';
	const hideLabel = label === null;

	const wrapperStyle = {
		...(fullWidth ? { width: '100%' } : {}),
		...(sx ?? {}),
	};

	return (
		<Controller
			name={name}
			control={control}
			defaultValue={defaultValue}
			render={({
				field: { onChange, onBlur, value, disabled },
				fieldState: { error },
			}) => {
				const shared = {
					label: labelText,
					hideLabel,
					size,
					value: value ?? '',
					onChange,
					onBlur: event => {
						onBlur();
						onChange(event.target.value.trim());
					},
					...(error?.message === undefined
						? {}
						: { error: error.message }),
					...(inputRef === undefined ? {} : { ref: inputRef }),
				};

				const field = multiline ? (
					<Textarea
						{...shared}
						{...(rows === undefined
							? {}
							: { minRows: Number(rows) })}
						{...(maxRows === undefined
							? {}
							: { maxRows: Number(maxRows) })}
						style={{ textAlign }}
						{...rest}
						disabled={disabled || rest.disabled}
					/>
				) : (
					<AkselTextField
						{...shared}
						style={{ textAlign }}
						{...rest}
						disabled={disabled || rest.disabled}
					/>
				);

				if (!prefix && !suffix && !fullWidth && !sx) {
					return <AkselLocale>{field}</AkselLocale>;
				}

				return (
					<AkselLocale>
						<div
							className="flex items-end gap-2"
							style={wrapperStyle}
						>
							{prefix && (
								<span className="pb-2 text-sm text-text-muted">
									{prefix}
								</span>
							)}
							<div className="min-w-0 flex-1">{field}</div>
							{suffix && (
								<span className="pb-2 text-sm text-text-muted">
									{suffix}
								</span>
							)}
						</div>
					</AkselLocale>
				);
			}}
		/>
	);
}
